<template>
  <div class="calico-search">
    <div
      :class="{
        field: true,
        active,
        error,
        disabled,
      }"
    >
      <input
        v-bind="filteredAttrs"
        :disabled="disabled"
        v-on="filteredListeners"
        @focus="active = true"
        @blur="(e) => (!e.target.value ? (active = false) : null)"
        @input="onInput"
      >      
    </div>
    <button
      class="button-utility button-utility-icon"
      @click="$emit('search', modelValue)"
    >
      <i class="bi bi-search black-fill" />
    </button>
  </div>
</template>

<script lang="js">
export default {
  name: 'CalicoSearch',
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    filteredAttrs () {
      const attrs = { ...this.$attrs }
      return attrs
    },
    filteredListeners () {
      const listeners = { ...this.$attrs }
      delete listeners.input
      return listeners
    }
  },
  methods: {
    onInput (event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>

<style scoped lang="scss">
.calico-search {
  display: flex;
  width: 100%;
  .field {
    @include inset-space($space-small);
    @include inline-space($space-xsmall);
    width: 100%;
    color: $color-neutral;
    border: 2px solid $color-neutral-light;
    border-top-left-radius: $radius-small;
    border-bottom-left-radius: $radius-small;
    border-right: none;
    background: $color-white;
    line-height: $line-height-medium;
  }

  input {
    width: 100%;
    height: 100%;
    border: none;
  }
  input:focus {
    outline: none;
  }

  button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    .bi {
      font-size: $icon-small;
    }
  }

  .active {
    color: $color-black;
    border: 2px solid $color-border-primary;
    border-right: none;
  }

  .disabled {
    color: $color-text-secondary;
    background: $color-neutral-lightest;
    border: 2px solid $color-neutral-lightest;
  }

  .error {
    color: $color-semantics-error;
    border: 2px solid $color-border-error;
    & > input {
      background: $color-background-error;
    }
    background: $color-background-error;
  }
}
</style>
